import { HealthRiskAssessment } from './HealthRiskAssessment';
import { HealthRiskAssessmentProvider } from './HealthRiskAssessment.context';

export const HealthRiskAssessmentWrapper = (): JSX.Element => {
	return (
		<HealthRiskAssessmentProvider>
			<HealthRiskAssessment />
		</HealthRiskAssessmentProvider>
	);
};
